import { LoadingStatusType, TaxDocumentType, TaxIncomeType } from "@/enums/enums";
import API from "@/service/Index";
import { ConvertToCommentLogPnd } from "@/service/pnd/pndFacade";
import { ConvertToCommentLogPP30 } from "@/service/pp30/pp30Facade";
import { ConvertToCommentLogWhtCertificate } from "@/service/withholding/withholdingFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Comment extends VuexModule {
  public commentListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public commentList: any = [];
  public addCommentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidCommentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private commentTaxDocumentId = 0;

  get getCommentListLoadingStatus(): LoadingStatusType {
    return this.commentListLoadingStatus;
  }
  get getCommentList(): any {
    return this.commentList;
  }
  get getAddCommentLoadingStatus(): LoadingStatusType {
    return this.addCommentLoadingStatus;
  }
  get getVoidCommentLoadingStatus(): LoadingStatusType {
    return this.voidCommentLoadingStatus;
  }

  @Mutation
  public SetCommentListLoadingStatus(status: LoadingStatusType) {
    this.commentListLoadingStatus = status;
  }
  @Mutation
  public SetCommentList(commentList: any) {
    this.commentList = commentList;
  }
  @Mutation
  public SetAddCommentLoadingStatus(status: LoadingStatusType) {
    this.addCommentLoadingStatus = status;
  }
  @Mutation
  public SetVoidCommentLoadingStatus(status: LoadingStatusType) {
    this.voidCommentLoadingStatus = status;
  }
  @Mutation
  public SetCommentTaxDocumentId(taxDocumentId: number) {
    this.commentTaxDocumentId = taxDocumentId;
  }

  @Action
  public DoGetCommentList(input: any) {
    if (this.commentTaxDocumentId !== input.id && this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Loading);
      this.context.commit("SetCommentTaxDocumentId", input.id);
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.GetCommentLogWhtCertificate(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentLogWhtCertificateList = ConvertToCommentLogWhtCertificate(res.data.data);
              this.context.commit("SetCommentList", commentLogWhtCertificateList);
            }
            this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.GetCommentLogPnd(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentLogPndList = ConvertToCommentLogPnd(res.data.data);
              this.context.commit("SetCommentList", commentLogPndList);
            }
            this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.GetCommentLogPP30Transaction(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
              this.context.commit("SetCommentList", commentLogPP30List);
            }
            this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.GetCommentLogPP30Form(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
              this.context.commit("SetCommentList", commentLogPP30List);
            }
            this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
      }
    }
  }
  @Action
  public DoAddComment(input: any) {
    if (this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Loading);
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.AddCommentLogWhtCertificate(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.WithholdingService.GetCommentLogWhtCertificate(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogWhtCertificateList = ConvertToCommentLogWhtCertificate(res.data.data);
                  this.context.commit("SetCommentList", commentLogWhtCertificateList);
                  this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.AddCommentLogPnd(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PndService.GetCommentLogPnd(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPndList = ConvertToCommentLogPnd(res.data.data);
                  this.context.commit("SetCommentList", commentLogPndList);
                  this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.AddCommentLogPP30Transaction(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PP30Service.GetCommentLogPP30Transaction(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
                  this.context.commit("SetCommentList", commentLogPP30List);
                  this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.AddCommentLogPP30Form(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PP30Service.GetCommentLogPP30Form(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
                  this.context.commit("SetCommentList", commentLogPP30List);
                  this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
      }
    }
  }
  @Action
  public DoVoidComment(input: any) {
    if (this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Loading);
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.VoidCommentLogWhtCertificate(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.WithholdingService.GetCommentLogWhtCertificate(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogWhtCertificateList = ConvertToCommentLogWhtCertificate(res.data.data);
                  this.context.commit("SetCommentList", commentLogWhtCertificateList);
                  this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.VoidCommentLogPnd(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PndService.GetCommentLogPnd(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPndList = ConvertToCommentLogPnd(res.data.data);
                  this.context.commit("SetCommentList", commentLogPndList);
                  this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.VoidCommentLogPP30Transaction(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PP30Service.GetCommentLogPP30Transaction(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
                  this.context.commit("SetCommentList", commentLogPP30List);
                  this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.VoidCommentLogPP30Form(input.data).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              API.PP30Service.GetCommentLogPP30Form(input.data.id).then((res) => {
                if (res.data.responseCode.IsSuccess()) {
                  const commentLogPP30List = ConvertToCommentLogPP30(res.data.data);
                  this.context.commit("SetCommentList", commentLogPP30List);
                  this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Success);
                }
              });
            }
          });
          break;
        }
      }
    }
  }
}
